import restaurants from './restaurants'
import widgets from './widgets'
import reservations from './reservations'
import waitlistEntries from './waitlistEntries'

const reservation = {
  restaurants,
  widgets,
  reservations,
  waitlistEntries,
}

export default reservation
